// v3/layouts/AuthLayout.tsx — Login layout
// Dark navy gradient background on all devices.
// Zero imports from v1/v2.

import { Outlet } from 'react-router-dom';

export function AuthLayout() {
  return (
    <div
      className="flex min-h-screen items-center justify-center p-4"
      style={{
        background: 'var(--m-chassis-grad)',
      }}
    >
      {/* bg-card, not white: the card must hold in designed dark too */}
      <div className="w-full max-w-sm rounded-xl border border-[var(--card-bd)] bg-card/95 backdrop-blur-sm shadow-lg">
        <Outlet />
      </div>
    </div>
  );
}
